import React from "react"
import PropTypes from "prop-types"

const TagItem = ({ data, isLast }) => (
  <span key={data.id} className="!leading-normal text-neutral-500 sm:text-lg">
    {data.name}
    <span className={`${isLast ? "hidden" : ""}`}>/</span>
  </span>
)

TagItem.propTypes = {
  data: PropTypes.object,
  isLast: PropTypes.bool,
}

export default TagItem
